import type { SVGProps } from 'react';
import type { SVGRType } from '../types';

const SvgBell = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRType) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 24 24'
    width='24'
    height='24'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M6.14774 16.952C5.42565 16.952 5 16.5872 5 16.0323C5 15.2722 5.7677 14.5881 6.42898 13.9116C6.93064 13.3872 7.06746 12.3078 7.12827 11.4337C7.18147 8.51496 7.95677 6.50831 9.97862 5.77862C10.2599 4.7829 11.0504 4 12.1677 4C13.2926 4 14.0755 4.7829 14.3644 5.77862C16.3862 6.50831 17.1615 8.51496 17.2147 11.4337C17.2755 12.3078 17.4124 13.3872 17.914 13.9116C18.5677 14.5881 19.343 15.2722 19.343 16.0323C19.343 16.5872 18.9097 16.952 18.1952 16.952H6.14774ZM12.1677 20C10.8831 20 9.94062 19.0575 9.8418 17.9933H14.5012C14.4024 19.0575 13.4599 20 12.1677 20Z' />
  </svg>
);

export default SvgBell;
